import { useEffect } from 'react';

/**
 * Custom React hook that automatically scrolls the page to the top
 * when the user reloads the page (i.e., presses F5 or refreshes the browser).
 *
 * It checks if the current navigation type is a 'reload', and if so,
 * waits until the DOM has been fully rendered before scrolling to the top.
 * This ensures a smooth and consistent user experience, especially when
 * the user was previously scrolled far down the page before reloading.
 */
const useScrollToTopOnReload = () => {
  useEffect(() => {
    // Check if we are in a browser environment
    if (typeof window === 'undefined' || typeof performance === 'undefined') return;

    const navEntries = performance.getEntriesByType?.('navigation');
    const navType = navEntries?.[0]?.type;

    if (navType === 'reload') {
      // We wait for the DOM to be fully rendered, not just for the page to be loaded
      const handleAfterLoad = () => {
        // We scroll to the top only if the current position is not already at the top
        if (window.scrollY > 0 || document.documentElement.scrollTop > 0) {
          window.scrollTo({ top: 0, behavior: 'smooth' });
        } else {
        }
      };

      // We use `requestAnimationFrame` to wait for the browser to render
      // the page content before performing the scroll
      requestAnimationFrame(handleAfterLoad);
    }
  }, []);
};

export default useScrollToTopOnReload;
